module.exports = __webpack_public_path__ + "static/lights8-c0a712060ec7fd4c5d4b672775e6eec7.jpg";